import React from 'react';
import { useSelector } from 'react-redux';
import Loader from '../components/Loader/Loader';
import { isLoading } from '../slice/commonSlice';

const PublicLayout = ({ children }) => {
  const loading = useSelector(isLoading);
  return (
    <>
      { loading ? <Loader /> : null }
      { children }
    </>
  );
};

export default PublicLayout;
